export default "__VITE_ASSET__7fkUe8Oe__"